import { BasicAvatar } from './basicAvatar';
import { AvatarVariant } from '../avatar.types';

export const IconDefaultAvatar: AvatarVariant = ({
  src,
  label,
  size,
  forceIsLoading,
  'aria-label': ariaLabel,
}) => (
  <BasicAvatar
    src={src}
    size={size}
    label={label}
    aria-label={ariaLabel}
    forceIsLoading={forceIsLoading}
  />
);
